import { AssignmentItemList } from '../../models/Assignment';

enum Label {
  RESUME = 'Resume',
  START_WORKING = 'Start Working',
  COMPLETED = 'Completed',
}

export const getLabelForAssignmentStudentDashboard = (itemList: AssignmentItemList) => {
  if (itemList.studentSkillAssignments?.every(item => item.submittedOn)) {
    return Label.COMPLETED;
  } else if (itemList.studentSkillAssignments?.some(item => item.submittedOn)) {
    return Label.RESUME;
  } else {
    return Label.START_WORKING;
  }
};
